import { createSelector } from 'reselect';

import { isContent } from '../../../common/elements/utils/elementTypeUtils';

export const elementCountSelector = createSelector(
    (state) => state.get('elementCount'),
    (elementCount) => elementCount,
);

export const contentElementCountSelector = createSelector(elementCountSelector, (elementCount) =>
    elementCount.filter((count, type) => isContent(type)),
);

export const contentTotalCountSelector = createSelector(contentElementCountSelector, (elementCount) =>
    elementCount.reduce((count, typeCount) => count + typeCount, 0),
);

export const contentTotalLimitSelector = (state) => state.getIn(['app', 'currentUser', 'contentLimit', 'current']);
export const contentLimitExceededSelector = (state) =>
    state.getIn(['app', 'currentUser', 'contentLimit', 'exceeded']) || false;
